var map = {
  "./desktop/LiveScore.js": [
    "94652",
    9,
    "9598",
    "75729",
    "66326",
    "30734",
    "63810",
    "26476",
    "566",
    "23456"
  ],
  "./desktop/Schedule.js": [
    "4215",
    9,
    "9598",
    "75729",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "72539"
  ],
  "./mobile": [
    "13898",
    9,
    "75729",
    "10981",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "7231",
    "36727"
  ],
  "./mobile/LiveScore.js": [
    "3578",
    9,
    "75729",
    "10981",
    "47387",
    "88565",
    "63810",
    "6532",
    "26476",
    "566",
    "26790"
  ],
  "./desktop": [
    "96196",
    9,
    "9598",
    "76225",
    "62815",
    "75729",
    "66326",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "7231",
    "16637"
  ],
  "./mobile/index": [
    "13898",
    9,
    "75729",
    "10981",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "7231",
    "36727"
  ],
  "./desktop/Schedule.scss": [
    "56259",
    7,
    "34752"
  ],
  "./desktop/index.js": [
    "96196",
    9,
    "9598",
    "76225",
    "62815",
    "75729",
    "66326",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "7231",
    "16637"
  ],
  "./desktop/index": [
    "96196",
    9,
    "9598",
    "76225",
    "62815",
    "75729",
    "66326",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "7231",
    "16637"
  ],
  "./desktop/LiveScore": [
    "94652",
    9,
    "9598",
    "75729",
    "66326",
    "30734",
    "63810",
    "26476",
    "566",
    "23456"
  ],
  "./mobile/Schedule.js": [
    "25069",
    9,
    "75729",
    "47387",
    "88565",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "95169"
  ],
  "./mobile/Schedule.scss": [
    "80663",
    7,
    "39010"
  ],
  "./mobile/Schedule": [
    "25069",
    9,
    "75729",
    "47387",
    "88565",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "95169"
  ],
  "./desktop/": [
    "96196",
    9,
    "9598",
    "76225",
    "62815",
    "75729",
    "66326",
    "47387",
    "3199",
    "77996",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "7231",
    "16637"
  ],
  "./mobile/": [
    "13898",
    9,
    "75729",
    "10981",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "7231",
    "36727"
  ],
  "./mobile/LiveScore": [
    "3578",
    9,
    "75729",
    "10981",
    "47387",
    "88565",
    "63810",
    "6532",
    "26476",
    "566",
    "26790"
  ],
  "./mobile/index.js": [
    "13898",
    9,
    "75729",
    "10981",
    "47387",
    "3199",
    "88565",
    "77996",
    "68454",
    "44944",
    "17189",
    "63810",
    "6532",
    "26476",
    "566",
    "73601",
    "7231",
    "36727"
  ],
  "./desktop/Schedule": [
    "4215",
    9,
    "9598",
    "75729",
    "30734",
    "63810",
    "26476",
    "566",
    "39704",
    "72539"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 92825;
module.exports = __rspack_async_context;
